(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-bet-information/assets/javascripts/printable-bet-information.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-bet-information/assets/javascripts/printable-bet-information.js');
"use strict";


const formatCurrency = svs.utils.format.Currency;
const PrintableBetInformation = _ref => {
  let price = _ref.price,
    system = _ref.system;
  return React.createElement("div", {
    className: "pb_print_bet_info"
  }, React.createElement("div", {
    className: "bet_amount"
  }, React.createElement("div", {
    className: "print_bet__label"
  }, "Pris"), "".concat(formatCurrency(price), " kr")), system && React.createElement("div", {
    className: "bet_system"
  }, React.createElement("div", {
    className: "print_bet__label"
  }, "System"), system));
};
setGlobal('svs.components.poolBetting.printableBetInformation.PrintableBetInformation', PrintableBetInformation);

 })(window);